let SUBMISSIONS_DOMAIN = "http://localhost:3001";
let RSS_URL_DOMAIN = "https://epawebapp.epa.ie";

switch (process.env.REACT_APP_EPA_ENV) {
  case "localhost":
    SUBMISSIONS_DOMAIN = "http://localhost:3001";
    RSS_URL_DOMAIN = "http://localhost:3001";
    break;

  case "inttest":
    SUBMISSIONS_DOMAIN = "https://lema-int.edenireland.ie";
    RSS_URL_DOMAIN = "https://epawebapp-test.epa.ie";
    break;

  case "bustest":
    SUBMISSIONS_DOMAIN = "https://lema-tst.edenireland.ie";
    RSS_URL_DOMAIN = "https://epawebapp-test.epa.ie";
    break;

  case "staging":
    SUBMISSIONS_DOMAIN = "https://lema-stg.epa.ie";
    RSS_URL_DOMAIN = "https://epawebapp-test.epa.ie";
    break;

  case "production":
    SUBMISSIONS_DOMAIN = "https://lema.epa.ie";
    RSS_URL_DOMAIN = "https://epawebapp.epa.ie";
    break;
}

export const RSS_PREFIX = `${SUBMISSIONS_DOMAIN}/licences/lic_eDMS/rss`;

export const GetSubmissionUrl = (regNo: string) => {
  return `${SUBMISSIONS_DOMAIN}/Submissions/Submission.aspx?p1=${regNo}`;
};

export const GetRssUrl = (regNo: string) => {
  return `${RSS_URL_DOMAIN}/licences/lic_eDMS/rss/${regNo}.xml`;
};
